import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { toast } from "react-hot-toast";
import {
  useGetAppraisalPeriodQuery,
  useGetHrDepartmentsQuery,
  useGetJobRoleQuery,
  useGetSingleAppraisalObjectiveQuery,
  useUpdateAppraisalObjectiveMutation,
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import {
  FormInput,
  FormSelect,
  FormTemplate,
  FormTextArea,
  CustomSearchableSelect,
} from "../../../../Components/Forms/InputTemplate";
export function EditObjectivesModal({
  id,
  isOpen,
  setIsOpen,
  isLoading,
  // refresh,
  // setRefresh,
  onValidate = () => {},
}) {
  const { data } = useGetSingleAppraisalObjectiveQuery(id);
  const [onUpdate] = useUpdateAppraisalObjectiveMutation();
  const { data: departments } = useGetHrDepartmentsQuery();
  const formMethods = useForm({
    defaultValues: {
      year: "",
      title: "",
      weight: "",
      description: "",
      departmentName: "",
      isGlobal: false,
    },
    mode: "all",
  });
  const {
    handleSubmit,
    formState: { isValid },
    reset,
    watch, trigger,
    setValue,
  } = formMethods;
  const watchDepartments = watch("selectedDepartments");
  const departmentOptions =
    departments?.responseObject?.pageItems?.map((dept) => ({
      value: dept.id,
      label: dept.name,
    })) || [];

  useEffect(() => {
    if (data?.responseObject && departments?.responseObject?.pageItems) {
      const departmentId = data?.responseObject?.departmentId;
      let selectedDepartments = [];

      if (departmentId !== null && departmentId !== undefined) {
        if (Array.isArray(departmentId)) {
          selectedDepartments = departmentId
            .map((id) => {
              const dept = departments.responseObject.pageItems.find(
                (department) => department.id === id
              );
              return dept ? { value: dept.id, label: dept.name } : null;
            })
            .filter(Boolean);
        } else {
          const existingDepartment = departments.responseObject.pageItems.find(
            (dept) => dept.id === departmentId
          );
          if (existingDepartment) {
            selectedDepartments = [
              {
                value: existingDepartment.id,
                label: existingDepartment.name,
              },
            ];
          }
        }
      }

      reset({
        jobRoleId:
          data?.responseObject?.designation?.id ||
          data?.responseObject?.jobRoleId ||
          data?.responseObject?.roleId,

        Year: data?.responseObject?.year?.toString() || "",
        title: data?.responseObject?.title,
        weight: data?.responseObject?.weight,
        selectedDepartments: selectedDepartments,
        description: data?.responseObject?.description,
        objectiveType:
          data?.responseObject?.objectiveType === "Global"
            ? 0
            : data?.responseObject?.objectiveType === "Operational"
            ? 1
            : 2,
        appraisalPeriod: data?.responseObject?.appraisalPeriodId,
        departmentId: data?.responseObject?.appraisalPeriodId,
      });
      trigger();
    }
  }, [data, departments, reset, trigger]);

  const { data: appraisalPeriod } = useGetAppraisalPeriodQuery({
    PageSize: 1000,
    ApprovalStatus: 0,
  });

  useEffect(() => {
    if (watchDepartments && Array.isArray(watchDepartments)) {
      const selectedDepartmentNames = watchDepartments.map(
        (dept) => dept.label
      );
      const selectedDepartmentIds = watchDepartments.map((dept) => dept.value);
      setValue("departmentNames", selectedDepartmentNames);
      setValue("departmentIds", selectedDepartmentIds);
    }
  }, [watchDepartments, setValue]);
  const submit = async (data) => {
    // Get the selected departments from the form data
    const selectedDepartments = data.selectedDepartments || [];
    const departmentIds = Array.isArray(selectedDepartments)
      ? selectedDepartments.map((dept) => dept.value)
      : [];
    const departmentNames = Array.isArray(selectedDepartments)
      ? selectedDepartments.map((dept) => dept.label)
      : [];

    // Determine if we should send a single value or array based on selection count
    const departmentIdValue =
      departmentIds.length === 1 ? departmentIds[0] : departmentIds;
    const departmentNameValue =
      departmentNames.length === 1 ? departmentNames[0] : departmentNames;

    const payload = {
      id,
      title: data.title,
      weight: parseInt(data.weight),
      departmentId: departmentIdValue,
      description: data.description,
      departmentName: departmentNameValue,
      objectiveType: parseInt(data.objectiveType),
      appraisalPeriodId: parseInt(data.appraisalPeriod),
      jobRoleId: parseInt(data?.jobRole),
    };

    console.log("Final edit payload:", payload);
    try {
      const response = await onUpdate(payload).unwrap();
      if (response?.successful) {
        toast.success(response?.statusMessage);
        onValidate();
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.data?.statusMessage);
    }
  };
  const objectiveType = [
    {
      value: "Global",
      key: 0,
    },
    {
      value: "Operational",
      key: 1,
    },
    {
      value: "Committee",
      key: 2,
    },
    {
      value: "Personnel",
      key: 3,
    },
  ];
  const months = [
    { label: "Months" },
    { label: "January" },
    { label: "February" },
    { label: "March" },
    { label: "April" },
    { label: "May" },
    { label: "June" },
    { label: "July" },
    { label: "August" },
    { label: "September" },
    { label: "October" },
    { label: "November" },
    { label: "December" },
  ];
  const { data: jobRole } = useGetJobRoleQuery({
    ApprovalStatus: 0,
    PageSize: 1000,
    PageNumber: 1,
  });
  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Set Up </h4>
          <h1 className="text-[28px] font-[800]">Objectives</h1>
          <p>Set measurable objectives aligned with the employee’s job role.</p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <FormInput
                title={"Objective Title"}
                camelCase={"title"}
                placeholder={"select"}
              />
              <FormSelect
                title={"Objective Type"}
                camelCase={"objectiveType"}
                placeholder={"select"}
                array={objectiveType.map((opt) => (
                  <option key={opt.value} value={opt.key}>
                    {opt.value}
                  </option>
                ))}
                defaultValue={0}
              />

              <FormInput
                title={"Weight"}
                camelCase={"weight"}
                placeholder={"select"}
              />
              <FormSelect
                title={"Appraisal Period"}
                camelCase={"appraisalPeriod"}
                placeholder={"select"}
                array={
                  appraisalPeriod?.responseObject?.result
                    ?.map((opt) => {
                      if (!opt) return null;

                      const startMonthIndex = parseInt(opt?.startMonth ?? 0);
                      const endMonthIndex = parseInt(opt?.endMonth ?? 0);

                      // Ensure we stay within bounds of months array (0-11)
                      const safeStartMonth =
                        startMonthIndex >= 0 && startMonthIndex < months.length
                          ? startMonthIndex
                          : 0;
                      const safeEndMonth =
                        endMonthIndex >= 0 && endMonthIndex < months.length
                          ? endMonthIndex
                          : 0;

                      return (
                        <option key={opt.id || opt.value} value={opt.id}>
                          Year: {opt.year || "N/A"} Start month:{" "}
                          {months[safeStartMonth]?.label || "N/A"} End Month:{" "}
                          {months[safeEndMonth]?.label || "N/A"}
                        </option>
                      );
                    })
                    .filter(Boolean) || []
                }
                defaultValue={0}
              />
              <CustomSearchableSelect
                title={"Departments"}
                camelCase={"selectedDepartments"}
                placeholder={"Select departments..."}
                options={departmentOptions}
                multiple={true}
                isOptional={false}
                moreRegister={{
                  onChange: (selectedOptions) => {
                    setValue("selectedDepartments", selectedOptions || []);
                  },
                }}
              />
              <FormSelect
                title={"Job Role"}
                camelCase={"jobRoleId"}
                placeholder={"select"}
                array={jobRole?.responseObject?.pageItems?.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt?.designationName}
                  </option>
                ))}
                defaultValue={"Select Job Role"}
                isOptional={true}
              />
              <FormSelect
                title={"Department"}
                camelCase={"DepartmentId"}
                placeholder={"select"}
                array={departments?.responseObject?.pageItems?.map((opt) => (
                  <option key={opt.value} value={opt.id}>
                    {opt.name}
                  </option>
                ))}
                defaultValue={0}
              />
              <div className="hidden">
                <FormInput
                  title={"Department Name"}
                  camelCase={"departmentName"}
                />
              </div>
              <FormTextArea
                className="h-[200px]"
                title={"Objective Description"}
                camelCase={"description"}
              />
              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <ActionButtons
                  isLoading={isLoading}
                  // disabled={!isValid}
                  width={"auto"}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  Update
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
}
